import HttpService from './HttpService';
import { pathApiConfig } from '../../__settings__/septSoftwarePaths';
import type { RuntimeTenantConfig } from '../../__settings__/runtimeConfig';

interface ConfigGetResponse {
  data: RuntimeTenantConfig;
}

const http = new HttpService();

class ConfigService {
  /** GET /api/config — the caller-tenant's runtime configuration (P1). */
  static async getConfig(): Promise<RuntimeTenantConfig> {
    const response = await http.get<ConfigGetResponse>(pathApiConfig);
    return response.data;
  }
}

export default ConfigService;
